import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getDiagnosis(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/diagnosis-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

let diagnosisCache: Promise<any> | null = null;

function getDiagnosisCached() {
  if (!diagnosisCache) {
    diagnosisCache = getDiagnosis().catch(err => {
      diagnosisCache = null;
      return Promise.reject(err);
    });
  }

  return diagnosisCache;
}

function clearDiagnosisCache() {
  diagnosisCache = null;
}

async function updateEtiologi(
  diagId: string,
  etiologi: { etiologi_id: string[] | string }
  // {
  //   id: number;
  //   name: string;
  //   options?: string[];
  //   need_text?: boolean;
  // }[]
) {
  const response = await http
    .putData(`/referensi/diagnosis-keperawatan/${diagId}/etiologi`, etiologi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function createEtiologi(
  diagId: string,
  etiologi: { etiologi_id: string[] | string }
  // {
  //   id?: number;
  //   name: string;
  //   options?: string[];
  //   need_text?: boolean;
  // }[]
) {
  const response = await http
    .postData(`/referensi/diagnosis-keperawatan/${diagId}/etiologi`, etiologi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateGejala(
  diagId: string,
  gejala: { gejala_id: string[] | string }
  // {
  //   gejala_id: number;
  //   name: string;
  //   options?: string[];
  //   need_text?: boolean;
  // }[]
) {
  const response = await http
    .putData(`/referensi/diagnosis-keperawatan/${diagId}/gejala`, gejala)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function createGejala(
  diagId: string,
  gejala: { gejala_id: string[] | string }
  // {
  //   gejala_id?: number;
  //   name: string;
  //   options?: string[];
  //   need_text?: boolean;
  // }[]
) {
  const response = await http
    .postData(`/referensi/diagnosis-keperawatan/${diagId}/gejala`, gejala)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

//-------------- Master Etiologi  ----------------
async function getEtiologi(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/etiologi-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function createMasterEtiologi(etiologi: {
  name: string;
  need_text: boolean;
  options: string[];
}) {
  const response = await http
    .postData(`/referensi/etiologi-keperawatan`, etiologi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function updateMasterEtiologi(
  id: string | number,
  etiologi: {
    name: string;
    need_text: boolean;
    options: string[];
  }
) {
  const response = await http
    .putData(`/referensi/etiologi-keperawatan/${id}`, etiologi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function deleteMasterEtiologi(id: string | number) {
  const response = await http
    .deleteData(`/referensi/etiologi-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

//-------------- Master Gejala  ----------------
async function getGejala(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/gejala-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function createMasterGejala(gejala: {
  name: string;
  need_text: boolean;
  options: string[];
}) {
  const response = await http
    .postData(`/referensi/gejala-keperawatan`, gejala)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function updateMasterGejala(
  id: string | number,
  gejala: {
    name: string;
    need_text: boolean;
    options: string[];
  }
) {
  const response = await http
    .putData(`/referensi/gejala-keperawatan/${id}`, gejala)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function deleteMasterGejala(id: string | number) {
  const response = await http
    .deleteData(`/referensi/gejala-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

//-------------- Master Hasil Luaran/Kriteria  ----------------
async function getHasilLuaran(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/hasil-luaran-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function createMasterHasilLuaran(name: { name: string }) {
  const response = await http
    .postData(`/referensi/hasil-luaran-keperawatan`, name)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function updateMasterHasilLuaran(
  id: string | number,
  name: { name: string }
) {
  const response = await http
    .putData(`/referensi/hasil-luaran-keperawatan/${id}`, name)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function deleteMasterHasilLuaran(id: string | number) {
  const response = await http
    .deleteData(`/referensi/hasil-luaran-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

//-------------- Master Luaran  ----------------
async function getLuaran(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/luaran-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function createMasterLuaran(luaran: {
  id: string;
  name: string;
  expectation: string;
  category: string;
  hasil: any[];
}) {
  const response = await http
    .postData(`/referensi/luaran-keperawatan`, luaran)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function updateMasterLuaran(
  id: string,
  luaran: {
    name: string;
    expectation: string;
    category: string;
    hasil: any[];
  }
) {
  const response = await http
    .putData(`/referensi/luaran-keperawatan/${id}`, luaran)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function deleteMasterLuaran(id: string) {
  const response = await http
    .deleteData(`/referensi/luaran-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

// ------------- Luaran  ----------------
async function updateLuaranHasil(id: string, hasil_id: any) {
  const response = await http
    .putData(`/referensi/luaran-keperawatan/${id}/hasil`, hasil_id)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateLuaran(
  diagId: string,
  data: { luaran: string[] | string }
) {
  const response = await http
    .putData(`/referensi/diagnosis-keperawatan/${diagId}/luaran`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

// ------------- Intervensi  ----------------
async function updateDiagnosisIntervensi(diagId: string, intervensi: string[]) {
  const response = await http
    .putData(`/referensi/diagnosis-keperawatan/${diagId}/intervensi`, {
      intervensi: intervensi
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getIntervensi(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/intervensi-keperawatan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function createIntervensi(
  intervensi: {
    id: string;
    name: string;
    item?: any[];
  }[]
) {
  const response = await http
    .postData(`/referensi/intervensi-keperawatan`, intervensi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateIntervensi(
  intId: string,
  intervensi: {
    name: string;
    item?: any[];
  }
) {
  const response = await http
    .putData(`/referensi/intervensi-keperawatan/${intId}`, intervensi)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

//------------- Tindakan Intervensi  ----------------
async function getTindakanIntervensi(search: string = undefined) {
  const response = await http
    .getDataParam(`/referensi/intervensi-keperawatan/tindakan`, {
      params: {
        search: search
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateTindakanIntervensi(
  intId: string,
  tindakan: {
    name: string;
    item?: any[];
  }
) {
  const response = await http
    .putData(`/referensi/intervensi-keperawatan/${intId}/tindakan`, tindakan)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function createMasterTindakan(
  tindakan: any
  // {
  //   id: string;
  //   name: string;
  //   item?: any[];
  // }[]
) {
  const response = await http
    .postData(`/referensi/tindakan-intervensi-keperawatan`, tindakan)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateMasterTindakan(
  tId: string,
  tindakan: {
    name: string;
    item?: any[];
  }
) {
  const response = await http
    .putData(`/referensi/tindakan-intervensi-keperawatan/${tId}`, tindakan)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getDiagnosis,
  getDiagnosisCached,
  clearDiagnosisCache,
  updateEtiologi,
  createEtiologi,
  updateGejala,
  createGejala,
  updateDiagnosisIntervensi,
  getIntervensi,
  createIntervensi,
  updateIntervensi,

  getTindakanIntervensi,
  createMasterTindakan,
  updateMasterTindakan,
  updateTindakanIntervensi,

  getGejala,
  createMasterGejala,
  updateMasterGejala,
  deleteMasterGejala,

  getEtiologi,
  createMasterEtiologi,
  updateMasterEtiologi,
  deleteMasterEtiologi,

  getHasilLuaran,
  createMasterHasilLuaran,
  updateMasterHasilLuaran,
  deleteMasterHasilLuaran,

  getLuaran,
  createMasterLuaran,
  updateMasterLuaran,
  deleteMasterLuaran,

  updateLuaranHasil,
  updateLuaran
};
